import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { EnvironmentNames } from '@mod/common/environment.model';

const ERROR_LOG_PREFIX = '[GlobalError]';
const TIMESTAMP_LABEL = 'timestamp';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler extends ErrorHandler {
  constructor() {
    super();
  }

  override handleError(error): void {
    if (
      environment.name === EnvironmentNames.Local ||
      environment.name === EnvironmentNames.Dev ||
      environment.name === EnvironmentNames.Staging
    ) {
      console.error(ERROR_LOG_PREFIX, error, { [TIMESTAMP_LABEL]: new Date().toLocaleString() });
    }
  }
}
